<template>
    <div class="avatar avatar-placeholder">
        <img v-if="avatar" class="avatar" :src="avatar">
        <div v-else-if="fallback" class="fallback" :style="`--background-color: ${fallbackColor}`"><span>{{ smiley }}</span></div>
    </div>
</template>

<script>
export default {
    name: 'avatar',
    props: {
        avatar: {
            type: String,
            default: null
        },
        fallback: {
            type: Boolean,
            default: true
        },
        fallbackColor: {
            type: String,
            default: '#00000050'
        },
    },
    data() {
        return {
        }
    },
    methods: {
    },
    computed: {
        smiley() {
            const smileys = [':)', ':D', ':P', ':(', ':o', ':3', '>:O', ';)', ':]', ':/'];
            const randomSmiley = smileys[Math.floor(Math.random() * smileys.length)];
            return randomSmiley;
        }
    },
}
</script>

<style lang="scss" scoped>
img {
    height: 100%;
    width: 100%;
    aspect-ratio: 1/1;
    object-fit: cover;
    border-radius: 50%;
}

.fallback {
    height: 100%;
    aspect-ratio: 1/1;
    border-radius: 50%;
    background: var(--background-color, #00000050);
    display: grid;
    place-items: center;

    span {
        color: #FFFFFFDD;
        letter-spacing: 2px;
        text-align: center;
    }
}
</style>